module.exports = __webpack_public_path__ + "img/basal_study.da337e4a.svg";